import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import * as actions from "../../../../../../../../../../store";
import PropTypes from "prop-types";
import {Divider, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {Skeleton} from "@material-ui/lab";

const ActivationSummaryContent = (props) => {
    const dispatch = useDispatch();
    const customerId = useSelector(state => state.authReducer.selectedCompany.integrationId);
    const summary = useSelector(state => state.ordiniConsipReducer.simSecondariaSummary.data)
    const loading = useSelector(state => state.ordiniConsipReducer.simSecondariaSummary.loading)

    const rows = [
        {subtitle1: "Utenza prioritaria", value1: summary.utenzaPrioritaria},
        {subtitle1: "Quale tipologia vuoi applicare?", value1: summary.tipologia},
        {
            subtitle1: "Vuoi attivare Ricarica Automatica?",
            value1: summary.attivareRicaricaAutomatica,
            subtitle2: "Tipologia di assenso",
            value2: summary.tipologiaDiAsseno
        },
        {subtitle1: "Vuoi attivare AutomaticaFast", value1: summary.attivareAutomaticafast},
        {
            subtitle1: "Quale comportamento vuoi applicare in caso di Over Plafond?", value1: "",
            subtitle2: "Comportamento Servizio Dati", value2: summary.comportamentoServizioDati
        },
        {
            subtitle1: "Vuoi attivazione il pacchetto giornaliero per il roaming extra Europa?",
            value1: summary.attivazionePacchettoRoamingExtraEuropa
        },
        {
            title: "Configurazione tecnica SIM",
            subtitle1: "APN",
            value1: summary.apn,
            subtitle2: "CLASSE ABILITAZIONE dati",
            value2: summary.classeAbilitazioneDati
        },
        {subtitle1: "INDIRIZZO E-MAIL REFERENTE", value1: summary.indirizzoEmailRefferente},
    ]

    useEffect(() => {
        dispatch(actions.getSimSecondariaSummary(customerId, props.selectedPrimary.seriale))
    }, [customerId, dispatch, props.selectedPrimary.seriale]);

    return (
        rows.map((item, index) => {
            return (
                <Grid container key={index}>
                    {item.title &&
                        <Grid item xs={12} className={"mb-6"}>
                            <Typography variant="subtitle1">
                                {item.title}
                            </Typography>
                        </Grid>
                    }
                    <Grid item container justifyContent="space-between">
                        <Grid item xs={12} md={4}>
                            <Typography variant={"overline"}>{item.subtitle1}</Typography>
                        </Grid>
                        <Grid item md={7}>
                            {loading ?
                                <Skeleton variant={"rect"} height={10}/> :
                                <Typography variant={"subtitle2"}>{item.value1}</Typography>
                            }
                        </Grid>
                    </Grid>
                    {item.subtitle2 &&
                        <Grid item container justifyContent="space-between" className={"mt-12"}>
                            <Grid item xs={12} md={4}>
                                <Typography variant={"overline"}>{item.subtitle2}</Typography>
                            </Grid>
                            <Grid item md={7}>
                                {loading ?
                                    <Skeleton variant={"rect"} height={10}/> :
                                    <Typography variant={"subtitle2"}>{item.value2}</Typography>
                                }
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} style={{marginTop: "1.5em"}}>
                        <Divider/>
                    </Grid>
                </Grid>
            )
        })
    )
}

ActivationSummaryContent.propTypes = {
    selectedPrimary: PropTypes.shape({
        id: PropTypes.string,
        numeroDiTelefono: PropTypes.string,
        seriale: PropTypes.string,
        dataOrdineDiConsegna: PropTypes.string,
        numeroOrdineDiConsegna: PropTypes.string
    }),
}
export default ActivationSummaryContent;